<template>
  <div ref="graph" class="graph" />
</template>
<script>
import GaugeChart from './d3-level-chart/d3-level-chart';

export default {
  name: 'EcsServiceLevelGraph',

  props: {
    serviceLevel: {
      type: Number,
      default: 0
    },
    graphThreshold: {
      type: Array,
      default() {
        return [20, 80];
      }
    }
  },

  data() {
    return {
      chart: new GaugeChart()
    };
  },

  watch: {
    serviceLevel() {
      this.chart.setPercentage(this.serviceLevel);

      this.chart.reRender(this.$refs.graph);
    },

    graphThreshold() {
      this.chart.setProperties({
        extraTicks: this.graphThreshold,
        color_threshold: [
          { color: '#f44336', finishStep: this.graphThreshold[0] },
          { color: '#ffc107', finishStep: this.graphThreshold[1] },
          { color: '#4ea96d', finishStep: 100 }
        ]
      });

      this.chart.reRender(this.$refs.graph);
    }
  },

  mounted() {
    this.chart.setProperties({
      rotation: 0,
      thickness: 0.2,
      arc: 1.4,
      ticks: 4,
      extraTicks: this.graphThreshold,
      color_step: 100,
      tick_color: 'transparent',
      // needle_color: 'red',
      color_threshold: [
        { color: '#f44336', finishStep: this.graphThreshold[0] },
        { color: '#ffc107', finishStep: this.graphThreshold[1] },
        { color: '#4ea96d', finishStep: 100 }
      ]
    });

    this.chart.setPercentage(this.serviceLevel);
    this.chart.create(this.$refs.graph);
  }
};
</script>

<style>
.needle path {
  stroke: #666;
}

[dark] .needle path {
  stroke: var(--v-surface-lighten4);
}
.tick-label text {
  fill: #666;
}
[dark] .tick-label text {
  fill: var(--v-surface-lighten4);
}
</style>
